<template>
  <div class="clickOverlay">
      <template v-for="(item, id) in this.vehicles">
         <MapVehicleEntry
           :key="id" 
           @click="vehicleClicked"
           v-bind:popupid="id" 
           :ref="id"
           v-bind:entry="item" 
           >
         </MapVehicleEntry>
      </template>
      <template v-for="(item, id) in this.stops">
         <MapStopEntry
           :key="id" 
           @click="stopClicked"
           v-bind:popupid="id" 
           :ref="id"
           v-bind:entry="item" 
           >
         </MapStopEntry>
      </template>
      <template v-for="(item, id) in this.devices">
         <MapDeviceEntry
           :key="id" 
           @click="deviceClicked"
           v-bind:popupid="id" 
           :ref="id"
           v-bind:entry="item" 
           >
         </MapDeviceEntry>
      </template>

  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'

import Overlay from 'ol/Overlay';

import MapStopEntry from '@/components/Map/MapStopEntry'
import MapDeviceEntry from '@/components/Map/MapDeviceEntry'
import MapVehicleEntry from '@/components/Map/MapVehicleEntry'

export default {
  name: 'ClickOverlay',
  components: {
    MapStopEntry,
    MapDeviceEntry,
    MapVehicleEntry
  },
  props: {
   // msg: String
    popupid: {type: String},
    featProps: {type:Array},
    map: {type: Object}
  },
  data() {
    return {
      id: null,
      overlay: null,
      feats: null,
      position: null,
      stops: {},
      vehicles: {},
      devices: {}
    }
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
  },
  mounted: function() {
    this.id = this.popupid;
    const $vm = this;
    if(Array.isArray(this.featProps) && this.featProps.length > 0) {
      //this.feats = Object.assign({}, this.featProps);
      this.feats = [...this.featProps];
      //this.feats = JSON.parse(JSON.stringify(this.featProps));
      //this.position = [...this.featProps.getGeometry().getFirstCoordinate()];
      this.position = this.feats[0].getGeometry().getFirstCoordinate();

      const overldiv = this.$el;
      const popup = new Overlay( {element: overldiv});
      this.overlay = popup;
      popup.setPosition(this.position);
      this.map.addOverlay(popup);
      this.feats.forEach( e => {
          const f = e.getProperties();
          //debugger;
          if(f.stopData) {
            $vm.$set($vm.stops, f.tunnus, f.stopData);
          } else if(f.deviceId) {
            if(f.infopointData)
              $vm.$set($vm.devices, f.deviceId, f.infopointData);
            else
              $vm.$set($vm.devices, f.deviceId, f.deviceData);
          } else if(f.vehicleData) {
            $vm.$set($vm.vehicles, f.vehicleData.vehicleId, f.vehicleData);
          }
      });
      }
  },
  beforeDestroy: function() {
    this.map.removeOverlay(this.overlay);
  },
  methods: {
    getId: () => {return this.popupid},
    closeMe: function() {
      this.$emit("close", this.popupid);
    },
    getOverlay: function() {
      return this.overlay;
    },
    stopClicked: function(tunnus) {
      const item = this.stops[tunnus];
      this.$emit('itemClicked', item);
      this.closeMe();
    },
    deviceClicked: function(tunnus) {
      const item = this.devices[tunnus];
      this.$emit('itemClicked', item);
      this.closeMe();
    },
    vehicleClicked: function(tunnus) {
      const item = this.vehicles[tunnus];
      this.$emit('itemClicked', item);
      this.closeMe();
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.clickOverlay {
  max-width: 90%;
  background-color: white;
  font-size: 0.6em;
  box-shadow: 0.2em 0.1em 4px 1px #0000008a;
  user-select: none;
}
</style>
